// extracted by mini-css-extract-plugin
export default {"container":"confirmation-popup_container__Zdqm+","header":"confirmation-popup_header__AVroJ"};